import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import IconButton from '@material-ui/core/IconButton'
import Switch from '@material-ui/core/Switch'
import TextField from '@material-ui/core/TextField'
import EditIcon from '@material-ui/icons/Edit'
import PropTypes from 'prop-types'
import React from 'react'

export default class OrganizationEditDialog extends React.Component {
    state = {
        remoteName: this.props.item.remoteName,
        propertyPassword: this.props.item.propertyPassword,
        active: this.props.item.active
    }

    handleClickOpen = () => {
        const { onOpen, item } = this.props
        onOpen(item.remoteId)
    }

    handleClose = () => {
        this.props.onClose()
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleActiveChange = () => {
        this.setState(state => ({ active: !state.active }))
    }

    handleSave = () => {
        const { item, onUpdate } = this.props
        const { remoteName, propertyPassword, active } = this.state

        onUpdate({
            ...item,
            remoteName,
            propertyPassword,
            active
        })
        this.handleClose()
    }

    render() {
        const { open, item } = this.props
        const { remoteName, propertyPassword, active } = this.state
        return (
            <div>
                <IconButton aria-label="Edit" onClick={this.handleClickOpen}>
                    <EditIcon />
                </IconButton>

                <Dialog open={open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">
                        Редактирование организации (Remote ID: {item.remoteId})
                    </DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            value={remoteName}
                            name="remoteName"
                            id="remoteName"
                            label="Имя организации Hostelworld.com"
                            onChange={this.handleChange}
                            fullWidth
                        />
                        <TextField
                            margin="dense"
                            value={propertyPassword}
                            name="propertyPassword"
                            id="propertyPassword"
                            label="PropertyPassword"
                            onChange={this.handleChange}
                            fullWidth
                        />

                        <FormControlLabel
                            control={<Switch checked={active} onChange={this.handleActiveChange} />}
                            label="Активна"
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            Отмена
                        </Button>
                        <Button onClick={this.handleSave} color="primary">
                            Сохранить
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

OrganizationEditDialog.propTypes = {
    item: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onOpen: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/HWTab/MappingTabs/OrganizationTab/OrganizationTable/OrganizationEditDialog.js